import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["activeStartDate", "firstDayOfWeek", "showOtherMonths"];
import React, { useContext, useMemo } from 'react';
import TileGroup from '../tiles/TileGroup';
import Day from './Day';
import { getDayOfWeek, getDaysInMonth, getMonthIndex, getYear, getFullDate } from '../../utils/dates';
import CalendarPickerContext from '../../context/CalendarPickerContext';
var Days = function Days(props) {
  var activeStartDate = props.activeStartDate,
    firstDayOfWeek = props.firstDayOfWeek,
    showOtherMonths = props.showOtherMonths,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var calculateNextEnd = function calculateNextEnd(daysInMonth, activeEndDate) {
    if (getDayOfWeek(activeEndDate, firstDayOfWeek) > 5) {
      return daysInMonth + (12 - getDayOfWeek(activeEndDate, firstDayOfWeek));
    } else {
      return daysInMonth + (5 - getDayOfWeek(activeEndDate, firstDayOfWeek));
    }
  };
  var _useContext = useContext(CalendarPickerContext),
    momentUtils = _useContext.momentUtils;
  var getDate = momentUtils.getDate,
    getStartDate = momentUtils.getStartDate;
  var _useMemo = useMemo(function () {
      var _activeStartDate = getDate(getStartDate(activeStartDate, 'month'));
      var start = -getDayOfWeek(_activeStartDate, firstDayOfWeek);
      if (start === -6) start = 1;
      var year = getYear(activeStartDate);
      var monthIndex = getMonthIndex(activeStartDate);
      var daysInMonth = getDaysInMonth(activeStartDate);
      var activeEndDate = getFullDate(year, monthIndex, daysInMonth);
      var end = calculateNextEnd(daysInMonth, activeEndDate);
      return [start, end, year, monthIndex];
    }, [activeStartDate, firstDayOfWeek]),
    start = _useMemo[0],
    end = _useMemo[1],
    year = _useMemo[2],
    monthIndex = _useMemo[3];
  return /*#__PURE__*/React.createElement(TileGroup, _extends({}, otherProps, {
    activeStartDate: activeStartDate,
    containerClassName: "ap-days",
    count: 7,
    dateTransform: function dateTransform(day) {
      return getFullDate(year, monthIndex, day);
    },
    dateType: "day",
    end: end,
    offset: 0,
    start: start,
    showOtherMonths: showOtherMonths,
    tile: Day,
    currentMonthIndex: monthIndex
  }));
};
export default Days;